import { RouteName } from "constant/routeNames";
import { Channel, ChannelBox, ChannelLogo } from "planby";
import { FaCrown } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import { Tooltip as ReactTooltip } from "react-tooltip";
import { useNavigate } from "react-router-dom";
import {
  clearLockedChannel,
  setCurrentChannelId,
  setLiveTVSuccess,
  setLockedChannel,
  setVideoStart,
} from "redux/VideoPlayerRedux";
import usePremiumAccess from "hooks/usePremiumAccess";
import { ContentType } from "services/subscription/types";
import PremiumContentModal from "components/PremiumContentModal";

interface ChannelItemProps {
  channel: Channel;
}

function ChannelItem({ channel }: ChannelItemProps) {
  const dispatch = useDispatch<any>();
  const navigate = useNavigate();
  const { position, logo } = channel;

  const video: any = { ...channel };
  const { currentLiveTv } = useSelector((state: any) => state?.video);
  const { isModalOpen, setIsModalOpen, checkAccess } = usePremiumAccess();

  const isPremiumContent = channel?.plan_id === 2;

  const channelClicked = async () => {
    const access = await checkAccess({
      contentType: ContentType.TV_CHANNELS,
      id: channel?.id,
      isPremiumContent,
      isCreator: false,
    });
    let newId: any = position.top / 80;
    if (!access) {
      await dispatch(setCurrentChannelId(newId));
      await dispatch(setLockedChannel(video));
      return;
    }

    await dispatch(clearLockedChannel());
    await dispatch(setVideoStart());
    await dispatch(setCurrentChannelId(newId));
    await dispatch(setLiveTVSuccess(video));

    navigate(RouteName.LiveTVPlayerLinkWithSlug.replace(":slug", video.slug));
  };

  return (
    <>
      <PremiumContentModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        isCreator={false}
      />
      <ChannelBox {...position}>
        <div
          className={`relative flex items-center overflow-hidden h-[70px] justify-between cursor-pointer bg-[#1a1919] hover:bg-slate-800 hover:shadow-xl text-gray-300 text-base font-thin rounded-md hover:text-white w-30 ${
            video?.uuid === currentLiveTv?.slug
              ? "bg-slate-800 border-2 border-red-500"
              : ""
          }`}
          onClick={channelClicked}
          data-tooltip-id={video.uuid}
        >
          {isPremiumContent && (
            <div className="absolute left-1/2 top-0 z-20 flex -translate-x-1/2 items-center gap-0.5 rounded-full border border-white/15 bg-black/40 px-1.5 py-0.5 text-[8px] font-semibold uppercase tracking-wide text-white shadow-lg backdrop-blur-md">
              <FaCrown className="text-[8px] text-[var(--red)]" />
              <span>Premium</span>
            </div>
          )}
          <ChannelLogo
            src={logo}
            alt="Logo"
            className={`rounded-md w-[74px] h-[74px] object-cover`}
          />
          <p className="mx-4">{video.channelNumber}</p>
        </div>
      </ChannelBox>
      <ReactTooltip
        id={video.uuid}
        place="right"
        content={video.name}
        className="!z-50 bg-slate-700 opacity-100"
      />
    </>
  );
}

export default ChannelItem;
